import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@valg-shared/components/tooltip/tooltip.module';
import { TranslateModule } from "@ngx-translate/core";
import { TextEllipsisTooltipRendererComponent } from './text-ellipsis-tooltip-renderer.component';
@NgModule({
  declarations: [
    TextEllipsisTooltipRendererComponent
  ],
  imports: [
    CommonModule,
    TooltipModule,
    TranslateModule
  ]
})
export class TextEllipsisTooltipRendererModule { }
